import { builderAdvantagesData } from './builderAdvantagesData'
import { BuilderAdvantagesCard } from './BuilderAdvantagesCard'
import classes from './BuilderAdvantages.module.scss'

export const BuilderAdvantages = () => {
  return (
    <div className={classes.list}>
      {builderAdvantagesData.map((item, idx) => (
        <BuilderAdvantagesCard key={idx} item={item} />
      ))}
    </div>
  )
}
